import React, { useEffect, useState, useRef } from "react";
import "./bothquote.css";
import axios from "axios";
import html2canvas from "html2canvas";
import { FaDownload, FaShare, FaShareAltSquare } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";

function TextQuote({ selectedTool, setSelectedTool }) {
  const [categories, setCategories] = useState([]);
  const [quotes, setQuotes] = useState([]);
  const [currentCategory, setCurrentCategory] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [categoryImages, setCategoryImages] = useState([]);
  const quotesPerPage = 9;
  const quoteRef = useRef(null);
  const myloc = useLocation().state;

  useEffect(() => {
    axios
      .post(
        "https://periodscalendar.preggyzone.com/api/Quotes/category_list_by_app_id",
        { app_id: 3 }
      )
      .then((response) => {
        setCategories(response.data.data);
        const motherCategory = response.data.data.find((category) =>
          category.category_name.toLowerCase().includes("mother")
        );
        if (motherCategory) {
          fetchQuotesByCategory(motherCategory.category_id);
          fetchCategoryImages(motherCategory.category_id);
        }
      })
      .catch((error) => console.error("Error fetching categories:", error));
  }, []);

  const fetchQuotesByCategory = (category_id) => {
    setCurrentPage(1);
    axios
      .post(
        "https://periodscalendar.preggyzone.com/api/Quotes/quotes_list_by_category_id",
        { quotes_category_id: category_id }
      )
      .then((response) => setQuotes(response.data.data || []))
      .catch((error) => console.error("Error fetching quotes:", error));
  };

  const fetchCategoryImages = (category_id) => {
    axios
      .post(
        "https://periodscalendar.preggyzone.com/api/Image/images_list_by_category_id",
        { images_category_id: 11 }
      )
      .then((response) => setCategoryImages(response.data.data))
      .catch((error) =>
        console.error("Error fetching category images:", error)
      );
  };

  const handleCategoryClick = (category_id) => {
    setCurrentCategory(category_id);
    fetchQuotesByCategory(category_id);
    fetchCategoryImages(category_id);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  // Pagination Logic..........................

  const startIndex = (currentPage - 1) * quotesPerPage;
  const endIndex = startIndex + quotesPerPage;
  const displayedQuotes = quotes.slice(startIndex, endIndex);

  const handleNextPage = () => {
    if (endIndex < quotes.length) {
      setCurrentPage((prev) => prev + 1);
      scrollToQuotes();
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
      scrollToQuotes(); // Scroll to quotes section
    }
  };


  const scrollToQuotes = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const getRandomCategoryImage = () => {
    if (categoryImages.length > 0) {
      const randomIndex = Math.floor(Math.random() * categoryImages.length);
      return categoryImages[randomIndex].image;
    }
    return null;
  };

  const handleDownload = (id) => {
    const quoteElement = document.getElementById(`quote-${id}`);

    if (quoteElement) {
      const buttons = quoteElement.querySelectorAll(
        ".download-btn, .share-btn"
      );
      buttons.forEach((btn) => (btn.style.visibility = "hidden"));

      html2canvas(quoteElement, {
        useCORS: true,
        allowTaint: true,
        scale: 2,

        backgroundColor: "red",
      }).then((canvas) => {
        const link = document.createElement("a");
        link.href = canvas.toDataURL("image/png");
        link.download = `quote-${id}.png`;
        link.click();
        buttons.forEach((btn) => (btn.style.visibility = "visible"));
      });
    }
  };

  const handleShare = (text) => {
    if (navigator.share) {
      navigator
        .share({
          title: "Inspirational Quote",
          text: text,
        })
        .catch((error) => console.error("Error sharing:", error));
    } else {
      alert("Sharing not supported on this device.");
    }
  };

  //  ......................................
  const totalPages = Math.ceil(quotes.length / quotesPerPage);

  const handlePageClick = (page) => {
    setCurrentPage(page);
    scrollToQuotes();
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const generatePageNumbers = () => {
    const pages = [];
    const maxPagesToShow = 5;

    if (totalPages <= maxPagesToShow) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 3) {
        pages.push(1, 2, 3, "...", totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(1, "...", totalPages - 2, totalPages - 1, totalPages);
      } else {
        pages.push(
          1,
          "...",
          currentPage - 1,
          currentPage,
          currentPage + 1,
          "...",
          totalPages
        );
      }
    }

    return pages;
  };

  useEffect(() => {
    if (myloc?.category_id) {
      setCurrentCategory(myloc.category_id);
    }
  }, []);

  return (
    <div className="quote-base">
      <div className="quote-main" style={{ paddingTop: "30px" }}>
        <div className="bread-container">
          <nav aria-label="breadcrumb">
            <ol className="crumb">
              <li className="breadcrumblist">
                <Link
                  to="/"
                  className="breadcrumb-link"
                  onClick={() => setSelectedTool("")}
                >
                  Home
                </Link>
              </li>
              <li className="breadcrumblist">
                <Link to="/quotes" className="breadcrumb-link">
                  Quotes
                </Link>
              </li>
              <li className="breadcrumblist active">TextQuotes</li>
            </ol>
          </nav>
        </div>
        <h1
          className="title"
          style={{ textAlign: "center", textTransform: "initial" }}
        >
          Text Quotes
        </h1>

        <div className="cat-contain">
          <div className="categories">
            {categories.length > 0 ? (
              categories.map((category, index) => (
                <div
                  key={category.id}
                  className={`category-btn ${
                    currentCategory == category.category_id
                      ? "active-category"
                      : ""
                  } ${index === 1 ? "first-category" : ""}`}
                  onClick={() => handleCategoryClick(category.category_id)}
                >
                  {category.category_name}
                </div>
              ))
            ) : (
              <p>No categories found.</p>
            )}
          </div>
        </div>

        <div className="quote-content pb-5" ref={quoteRef}>
          <div className="text-quotes">
            {displayedQuotes.length > 0 ? (
              displayedQuotes.map((quote, index) => {
                const backgroundImage = getRandomCategoryImage();
                return (
                  <div
                    key={index}
                    id={`quote-${index}`}
                    className="quote-item"
                    style={{
                      backgroundImage: `url(${backgroundImage})`,
                      backgroundColor: "black",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      padding: "20px",
                      textAlign: "center",
                      position: "relative",
                    }}
                  >
                    <h4 style={{ color: "white" }}>{quote.quotes_name}</h4>
                    <p className="quote-text" style={{ color: "white" }}>
                      "{quote.author}"
                    </p>

                    {/* Buttons */}
                    <div className="quote-actions">
                      <button
                        className="download-btn"
                        onClick={() => handleDownload(index)}
                      >
                        <FaDownload />

                        {/* Download Icon */}
                      </button>
                      <button
                        className="share-btn"
                        onClick={() => handleShare(quote.quotes_name)}
                      >
                        <FaShareAltSquare />
                      </button>
                    </div>
                  </div>
                );
              })
            ) : (
              <p>No quotes found for this category.</p>
            )}
          </div>
        </div>

        {/* Pagination Controls */}
        <div className="text-pagination-controls">
          <button onClick={handlePrevPage} disabled={currentPage === 1}>
            Previous
          </button>

          {generatePageNumbers().map((page, index) => (
            <button
              key={index}
              onClick={() => page !== "..." && handlePageClick(page)}
              disabled={page === "..."}
              className={currentPage === page ? "active-page" : ""}
            >
              {page}
            </button>
          ))}

          <button
            onClick={handleNextPage}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
}

export default TextQuote;
